import EventApi from '@/api/event';

const SubscriptionPlusEventApi = {
  /**
   * 유저의 이벤트 참여 여부 조회 API
   */
  checkUserHasJoined: async () => {
    try {
      const response = await EventApi.get(
        `/subscription_plus_event_api.php?szWork=checkEventUser`,
      );
      return response;
    } catch (e) {
      console.error(e);
      return e;
    }
  },
  /**
   * 이벤트 참가 신청 API
   */
  joinEvent: async () => {
    try {
      const response = await EventApi.post(`/subscription_plus_event_api.php`, {
        szWork: 'join',
      });
      return response;
    } catch (e) {
      console.error(e);
      return e;
    }
  },
  /**
   * 이벤트 기간 동안 구독+ 상품 구매 개수 조회 API
   */
  checkEventSubscriptionPlusCount: async () => {
    try {
      const response = await EventApi.get(
        `/subscription_renewal_event_api.php?type=ChkEventSubscriptionPlus`,
      );
      return response;
    } catch (e) {
      console.error(e);
      return e;
    }
  },
};

export default SubscriptionPlusEventApi;
